<template>
    <div id="app">
        <PatientEligibility :Type="AppServiceID" />
    </div>
</template>

<script>
import Vue from 'vue';
import PatientEligibility from '@/components/Common/PatientEligibility.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

  data: function (){
        return {
        AppServiceID :'',
        }
    },
    components: {
        PatientEligibility
    },
 
    created: function() { 
        console.log('i am here')
        this.$emit('update:layout', LayoutDefault);
        this.AppServiceID = this.$store.getters.GetOpticalID;
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetOpticalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetOpticalID);
    },
}
</script>

<style>

</style>
